<template>
  <div class="supply">
    
    <div class="hard">
      <div class="big-title">
        <p>多种营销方式</p>
        <div class="line"></div>
        <div class="desc">
          利用营销方式的多样化增加用户粘性，促进运营推广
        </div>
      </div>
      <div class="hard-box">
        <img class="hard-now" src="../../static/images/solution/wisdom111.png" alt="" />
        <div class="hard-cont">
          <div class="hard-item" v-for="(item,index) in hardArr" :key="index">
            <img :src="item.img" alt="" />
            <h2>{{ item.title }}</h2>
          </div>
        </div>
      </div>
    </div>

    <div class="frame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          一站式智能化场馆建设服务
        </div>
      </div>
      <img src="../../static/images/solution/wisdom7.png" alt="" />
    </div>
    

    <div class="system">
      <div class="big-title">
        <p>核心价值</p>
        <div class="line"></div>
        <div class="desc">
          建立以现代通信和信息技术为基础，以游客体验为中心，以一体化的行业管理为保障，以激励旅游产业创新、促进产业升级为特色的新旅游目的地。
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="(item,index) in systemArr" :key="index">
          <img :src="item.img" alt="" />
          <div>
              <h5>{{ item.title }}<span>{{ item.cont }}</span></h5>
              <h6>{{ item.desc }}</h6>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/wisdom2.png"),
          title: "景区游客流量不足，营销成本太高",
        },
        {
          id: 1,
          img: require("../../static/images/solution/wisdom3.png"),
          title: "景区销售体系建设难度大，效率低下",
        },
        {
          id: 2,
          img: require("../../static/images/solution/wisdom4.png"),
          title: "景区收入来源单一，现金流不足",
        },
        {
          id: 3,
          img: require("../../static/images/solution/wisdom5.png"),
          title: "景区技术能力差，互联网应用水平低，游客体验差",
        },
        {
          id: 4,
          img: require("../../static/images/solution/wisdom6.png"),
          title: "景区与游客不能建立关联，二次消费收入低迷",
        },
      ],
      //核心价值
      systemArr: [
        {
          id: 0,
          title:'创新营销',
          cont:'提升盈利',
          desc: "线上线下自动引流，多渠道推广，采用全新营销手段，大幅提升景区收入。",
          img: require("../../static/images/solution/wisdom8.png"),
        },
        {
          id: 1,
          title:'高效信息化 ',
          cont:'提高业务力',
          desc: "高效整合信息化系统，实现服务，营销，管理的智慧化，采用智能广播，视频监控，预警与应急指挥调度，提高快速处理突发事件的能力。",
          img: require("../../static/images/solution/wisdom9.png"),
        },
        {
          id: 2,
          title:'二维码消费 ',
          cont:'实现高效经营',
          desc: "游客通过微信扫描二维码进行消费，所有资金直接进入景区账户，景区可自行投资旅游产品或项目通过系统有效的管理和经营。",
          img: require("../../static/images/solution/wisdom10.png"),
        },
        {
          id: 3,
          title:'创新技术 ',
          cont:'一站式智慧旅游',
          desc: "利用新的互联网思维和技术，结合景区自身特点定制适合的景区电商平台，实现游客网络购票，720全景，语音解说，一键导航等一站式智慧旅游服务。",
          img: require("../../static/images/solution/wisdom11.png"),
        },
        {
          id: 4,
          title:'沉淀消费者 ',
          cont:'建立数据模型',
          desc: "对沉淀游客的消费行为、消费足迹，建立游客数据模型，自动识别不同消费能力的潜在游客。",
          img: require("../../static/images/solution/wisdom12.png"),
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 0;
}

.hard {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .hard-box {
    width :1060px;
    height :380px;
    display :flex;
    justify-content :space-between
    margin :0 auto
  }
  .hard-now{
    width:528px;
    height :380px
  }
  .hard-cont{
    width :688px;
    display: flex;
    flex-wrap:wrap;
    justify-content :flex-start 
    align-items :center
  }

  .hard-item {
    width: 520px;
    height: 72px;
    background: rgba(255,255,255,0.3);
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    align-items :center;
    justify-content: flex-start;
    img{
      width:40px;
      height :40px;
      margin :0 20px 0 50px
    }
    h2 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

  }
}
.frame{
  text-align :center
  margin:0 0 80px 0
}



.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;

  .system-box {
    display: flex;
    justify-content :space-between
  }

  .system-item {
    width: 262px;
    height: 322px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 8px;
    padding:0 24px;
    text-align :center
    img{
      width :58px;
      height :58px
      margin:32px 0
    }

    h5{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 23px 0;
      span{
        color :#FFC000
      }
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
  }
}

.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

  .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 58px;
    line-height: 28px;
  }
}


.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionWisdom.vue